//
//
//
//
//

export default {
	data() {
		return {
			planBScroll: null,
			addEventListenerDone: false,
		};
	},
	mounted() {
		this.addTouch();
	},
	activated() {
		this.addTouch();
	},
	beforeDestroy() {
		this.removeTouch();
	},
	deactivated() {
		this.removeTouch();
	},
	methods: {
		handler(ev) {
			ev.preventDefault();
		},
		addTouch() {
			document.body.addEventListener("touchmove", this.handler, {
				passive: false,
			});
		},
		removeTouch() {
			document.body.removeEventListener("touchmove", this.handler, {
				passive: false,
			});
		},
		close() {
			this.$emit("layeClick");
		},
	},
};
